import React, { useMemo } from 'react'
import Select, { type SingleValue, type StylesConfig } from 'react-select'
import { hydroReactSelectStyles } from '@/lib/hydroReactSelectStyles'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'
import type { DeviceRole } from '../context/DeviceContext'

type OutletOption = { value: string; label: string }

const OUTLET_OPTIONS: OutletOption[] = [
    { value: 'Humidifier', label: 'Humidifier' },
    { value: 'Dehumidifier', label: 'Dehumidifier' },
    { value: 'Exhaust Fan', label: 'Exhaust Fan' },
    { value: 'Fan', label: 'Fan' },
    { value: 'AC', label: 'AC Unit' },
    { value: 'Pump', label: 'Pump' },
    { value: 'Heater', label: 'Heater' },
    { value: 'Light', label: 'Grow Light' },
]

const outletSelectStyles = hydroReactSelectStyles as StylesConfig<OutletOption, false>

type OutletTypeProps = {
    outletNumber: number
    outlets: DeviceRole[]
    setOutlets: React.Dispatch<React.SetStateAction<DeviceRole[]>>
}

const OutletType = ({ outletNumber, setOutlets, outlets }: OutletTypeProps) => {
    const value: OutletOption | null = useMemo(() => {
        const role = outlets.find((o) => o?.outlet === outletNumber)?.role
        if (!role) return null
        return OUTLET_OPTIONS.find((o) => o.value === role) ?? { value: role, label: role }
    }, [outlets, outletNumber])

    return (
        <div className="flex w-full min-w-0 flex-col gap-2">
            <Label className="text-sm text-zinc-300">Outlet {outletNumber + 1}</Label>
            <Select<OutletOption, false>
                instanceId={`outlet-type-${outletNumber}`}
                inputId={`outlet-type-input-${outletNumber}`}
                classNamePrefix="hydro-outlet-type"
                options={OUTLET_OPTIONS}
                value={value}
                placeholder="Choose device…"
                onChange={(opt: SingleValue<OutletOption>) => {
                    const role = opt?.value ?? ''
                    setOutlets((prev) => {
                        const next = prev.filter((o) => o?.outlet !== outletNumber)
                        next.push({
                            outlet: outletNumber,
                            role,
                            status: 'off',
                        })
                        return next
                    })
                }}
                styles={outletSelectStyles}
                menuPortalTarget={
                    typeof document !== 'undefined' ? document.documentElement : undefined
                }
                menuPosition="fixed"
                menuPlacement="auto"
                isSearchable={false}
                blurInputOnSelect
                className={cn('w-full min-w-0')}
            />
        </div>
    )
}

export default OutletType
